import { useQuery } from 'react-query';
import { allCommissionsByMonthQuery } from './useCommissionsByMonth.query';
import {
  CommissionsByMonthQueryResponse,
  UseCommissionsByMonthQueryParams,
} from './useCommissionsByMonth.types';

export const ALL_COMMISSIONS_BY_MONTH_QUERY_KEY = 'ALL_COMMISSIONS_BY_MONTH';

export const useCommissionsByMonth = (params: UseCommissionsByMonthQueryParams) => {
  return useQuery<CommissionsByMonthQueryResponse, Error>(ALL_COMMISSIONS_BY_MONTH_QUERY_KEY, () =>
    allCommissionsByMonthQuery(params)
  );
};
